import {
  ExternalLink,
  Image,
  LayoutDashboard,
  LayoutGrid,
  Package,
  Settings,
  type LucideIcon,
} from "lucide-react";

export type AdminNavItem = {
  label: string;
  to: string;
  icon: LucideIcon;
  end?: boolean;
  external?: boolean;
};

export const ADMIN_NAV: AdminNavItem[] = [
  { label: "Dashboard", to: "/admin", icon: LayoutDashboard, end: true },
  { label: "Products", to: "/admin/products", icon: Package },
  { label: "Hero", to: "/admin/hero", icon: Image },
  { label: "Categories", to: "/admin/categories", icon: LayoutGrid },
  { label: "Settings", to: "/admin/settings", icon: Settings },
];

export const ADMIN_STOREFRONT_LINK: AdminNavItem = {
  label: "View storefront",
  to: "/",
  icon: ExternalLink,
  external: true,
};
